import JobsInquiryHiringsCountQuery from '@/apollo/queries/Jobs/JobsInquiryHiringsCount.query';
import { Component, Vue } from 'nuxt-property-decorator';
@Component<JobsHiringsCountMixin>({
  apollo: {
    hiringCount: {
      query: JobsInquiryHiringsCountQuery,
      error(e): void {
        this.$notice.error(e);
      },
      update(data) {
        return data.currentJobsInquiry?.hiringsForReview?.length;
      },
      skip() {
        return !this.$auth.loggedIn;
      },
    },
  },
})
export default class JobsHiringsCountMixin extends Vue {
  hiringCount: number | null = null;
}
